import React from 'react';
import FileList from './components/FileList/FileList'
import Upload from './components/Upload'
import GigList from './components/Gig/GigList'
import Loading from './components/Loading'
import EditFile from './components/FileList/EditFile'
import EditGig from './components/Gig/EditGig'
import { observer } from 'mobx-react-lite'
import AppState from './AppState';

interface Props {state: AppState}

const App = observer(({state}: Props) => {
    if (!state.config || !state.initialized) {
        return <Loading loading={true}>
            <p className="loading-app">Loadink hyper front-end...</p>
        </Loading>
    }

    const stateProps = {
        state: state
    }

    return (
        <div id="approot">
            <GigList {...stateProps} />
            {
                state.config.admin ? <Upload state={state} /> : null
            }
            <Loading loading={state.filesLoading}>
                {
                    state.config.tables?.map(tableConfig => {
                        const FileListProps = {
                            ...stateProps,
                            key:tableConfig.id,
                            tableConfig:tableConfig
                        }
                        return <FileList {...FileListProps} />
                        }
                    )
                }
            </Loading>
            {
                state.config.admin ? 
                <React.Fragment>
                    <EditGig {...stateProps}  />
                    <EditFile {...stateProps}  />
                </React.Fragment> : null
            }
        </div>
    );
})

export default App;
